module.exports = __webpack_public_path__ + "img/quizz-step-11-4.c1fa1f1a.jpg";